import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: `bridges px-0 mx-0 theme--${_vm.UiTheme ? 'dark' : 'light'}`
  }, [_c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.areYouSure'),
      "open": _vm.deleteDialog,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete',
        disabled: !_vm.deleteButtonEnabled
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deleteDialog = false;
      },
      "cancel": function ($event) {
        _vm.deleteDialog = false;
      },
      "delete": function ($event) {
        return _vm.handleDeleteConnector(_vm.deleteBridgeId);
      }
    }
  }, [!_vm.connectorDependenciesFetched ? _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center p-3"
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "size": 50
    }
  })], 1)])], 1)], 1) : _vm._e(), _vm.connectorDependenciesFetched && _vm.hasConnectorDependencies ? _c('div', [_c('div', {
    staticClass: "accountInfoBox"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Connectors.connectorHasRelatedObjects')) + "\n        "), _c('br'), _c('br'), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.deviceTemplatesTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e(), item.id ? [_c('a', {
          attrs: {
            "href": `/#/device-templates/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n              " + _vm._s(item.title) + "\n            ")], _vm._v("\n             \n            "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 4120317573)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.virtualDevicesTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e(), item.id ? [_c('a', {
          attrs: {
            "href": `/#/virtual-devices/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n              " + _vm._s(item.title) + "\n            ")], _vm._v("\n             \n            "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 672143284)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.digitalTwinsTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e(), item.id ? [_c('a', {
          attrs: {
            "href": `/#/digitaltwin-mgmt?active=${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n              " + _vm._s(item.title) + "\n            ")], _vm._v("\n             \n            "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1975302418)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.integrationFlowsTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e(), item.id ? [_c('a', {
          attrs: {
            "href": `/#/connectors/consumers/list`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n              " + _vm._s(item.title) + "\n            ")], _vm._v("\n             \n            "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 2230661335)
  })], 1)]) : _vm._e()]), _vm.hasNoConnectors ? _c('core-empty-state', {
    attrs: {
      "icon": "fas fa-plug",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Connectors.listEmpty.title')) + "\n    ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right"
          },
          on: {
            "click": function ($event) {
              return _vm.showCreateDialog();
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Connectors.listEmpty.button')) + "\n      ")])];
      },
      proxy: true
    }], null, false, 548884734)
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Connectors.listEmpty.description')) + "\n    ")])]) : _vm.shouldShowTable ? [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "search_connector",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "click:clear": function ($event) {
        _vm.searchItem = '';
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "data-cy": "connector_data_table",
      "data-cy-state": _vm.isLoadingConnectors ? 'loading' : 'loaded',
      "loading": _vm.isLoadingConnectors,
      "items": _vm.tableBridges,
      "server-items-length": _vm.totalItemsCount,
      "options": _vm.tableOptions,
      "item-key": "id",
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footer
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', {
          key: items.item.id
        }, [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "70px"
          }
        }, [_vm._v(_vm._s(items.item.id))]), _c('td', [items.item.state === 'error' ? _c(VTooltip, {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VIcon, _vm._g({
                attrs: {
                  "color": "danger"
                }
              }, on), [_vm._v("fal fa-times-circle")])];
            }
          }], null, true)
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tooltips.error')) + "\n            ")]) : items.item.state === 'active' ? _c(VIcon, {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("fal fa-check-circle")]) : items.item.state === 'disabled' ? _c(VIcon, {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("fal fa-lightbulb-slash")]) : _c(VIcon, {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("fal fa-minus-circle")])], 1), _c('td', [_vm._v(_vm._s(items.item.name))]), _c('td', [_vm._v(_vm._s(items.item.displayName))]), _c('td', {
          staticClass: "text-center"
        }, [_c(VTooltip, {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [items.item.table.kind === 'both' ? _c(VIcon, _vm._g({}, on), [_vm._v("fal fa-long-arrow-down")]) : _vm._e(), items.item.table.kind === 'both' ? _c(VIcon, _vm._g({}, on), [_vm._v("fal fa-long-arrow-up")]) : _vm._e(), items.item.table.kind === 'inbound' ? _c(VIcon, _vm._g({}, on), [_vm._v("fal fa-long-arrow-down")]) : _vm._e(), items.item.table.kind === 'outbound' ? _c(VIcon, _vm._g({}, on), [_vm._v("fal fa-long-arrow-up")]) : _vm._e()];
            }
          }], null, true)
        }, [items.item.table.kind === 'both' ? [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tooltips.biDirectional')) + "\n              ")] : _vm._e(), items.item.table.kind === 'inbound' ? [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tooltips.inbound')) + "\n              ")] : _vm._e(), items.item.table.kind === 'outbound' ? [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Connectors.Connectors.tooltips.outbound')) + "\n              ")] : _vm._e()], 2)], 1), _c('td', [_vm._v(_vm._s((_vm.accounts.find(account => account.id === items.item.tenantId) || {}).name))]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.createdAt)))]), _c('td', [_c('router-link', {
          attrs: {
            "to": `/connectors/edit/${items.item.tenantId}/${items.item.id}`,
            "data-cy": "edit_btn"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-edit")])], 1), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.openDeleteDialog(items.item.id);
              _vm.deleteBridgeId = items.item.id;
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])], 1)])];
      }
    }])
  })] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };